import { Fold } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import { _Col2CollectionitemImage } from "../optics";
export const _categoryStandAlone = Fold.liftM((attributes, image) => ({
    titleM: attributes.title,
    descriptionM: attributes.description,
    image: image,
}), Optics._Col2Attributes, _Col2CollectionitemImage);

